import { create } from 'zustand';

interface AppDownloadState {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
  setIsOpen: (isOpen: boolean) => void;
}

export const useAppDownloadStore = create<AppDownloadState>((set) => ({
  isOpen: false,
  openModal: () => set({ isOpen: true }),
  closeModal: () => set({ isOpen: false }),
  setIsOpen: (isOpen) => set({ isOpen }),
}));
